import { Redirect } from 'react-router-dom'

const RedirectHome = () => {
    return (
        <Redirect to="/sistema/dashboards" />
    )
}

export default RedirectHome